import React, {Component} from 'react';
import {Col, Container, FormFeedback, FormGroup, FormText, Input, Label, Button as Button2, Row} from 'reactstrap';

import Button from '../../../shared/components/Button';
import Form from '../../../shared/components/Form';
import DroppableFileInput from '../../../shared/components/DroppableFileInput';
import DateInput from "react-datepicker";
import moment from "moment";
import {DABBL_COLOR, isAlphaNumeric} from "../../../shared/utils";
import ColorInput from '../../../shared/components/ColorInput';


class EditPromotion extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ctaColorValid: true,
            isUpdating: false,
            isActivating: false,
            campaign: null,
            upc: '',
            error: null,
            validateForm: false
        }
    }

    componentWillMount() {
        const {promotion} = this.props
        if (promotion) {
            this.setState({...promotion,
                startDate: promotion.startDate ? moment(moment.utc(promotion.startDate).format('LL')).startOf('day') : moment(),
                endDate: promotion.endDate ? moment(moment.utc(promotion.endDate).format('LL')).startOf('day') : moment(),
                ctaColor: promotion.ctaColor || DABBL_COLOR,
                codes: promotion.codes || [],
                count: promotion.count || 0,
                shouldSubmitCodes: false,
                validateForm: true});
        } else {
            this.setState({
                name: '',
                imageURL: '',
                headline: '',
                message: '',
                legal: '',
                ctaUrl: '',
                ctaCopy: '',
                ctaColor: DABBL_COLOR,
                startDate: moment(),
                endDate:  moment(this.state.startDate).add(7, "day"),
                codes: [],
                count: 0,
                shouldSubmitCodes: true
            });
        }
    }

    componentDidMount(){
    }

    componentWillUpdate(newProps, newState) {
        if (!newProps.isCreate && newProps.promotion && !this.props.promotion){
            const {promotion} = newProps
            this.setState({...promotion,
                name: promotion.name,
                brandId: promotion.brandId,
                imageURL: promotion.imageURL,
                status: promotion.status,
                headline: promotion.headline,
                message: promotion.message,
                legal: promotion.legal,
                startDate: promotion.startDate ? moment(moment.utc(promotion.startDate).format('LL')).startOf('day') : moment(),
                endDate: promotion.endDate ? moment(moment.utc(promotion.endDate).format('LL')).startOf('day') : moment(),
                ctaUrl: promotion.ctaUrl,
                ctaCopy: promotion.ctaCopy,
                ctaColor: promotion.ctaColor,
                codes: promotion.codes || [],
                count: promotion.count || 0,
                validateForm: true,
                shouldSubmitCodes: false,
                isCreate: false});
        }
    }

    handleColorChange(color) {
        const isValid = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);
        if (isValid) {
            this.setState({
                ctaColor: color,
                ctaColorValid: isValid
            })
        } else {
            this.setState({ctaColorValid: isValid})
        }
    }

    clearCodes(e){
        e.preventDefault()
        console.log(`clear codes`)
        this.setState({codes: [], shouldSubmitCodes: true, count: 0})
    }

    handleFileUploadChange(e){
        let reader = new window.FileReader();
        reader.onload = (e1) => {
            let codesToAdd = reader.result.split(/[,(\r?\n)\n]/).filter((code) => (code !== ''))
            let codes = this.state.codes.concat(codesToAdd)
            this.setState({codes: codes, shouldSubmitCodes: true, count: codes.length})
            // for(let [key, upc] in upcs) {
            //     console.log(upc)
            // }
        }
        reader.readAsText(e.target.files[0]);
        e.target.value = ''
    }

    isValidPromotion() {
        const {name, imageURL, headline, message, legal, startDate, endDate, ctaUrl, ctaCopy, ctaColor, codes, count, shouldSubmitCodes, ctaColorValid} = this.state
        return name && imageURL && headline && message && legal && startDate < endDate && ctaUrl && ctaCopy && ctaCopy.length <= 25 && ctaColor  && ctaColor && ctaColorValid && (shouldSubmitCodes && codes && codes.length > 0 || !shouldSubmitCodes)
    }

    handleSubmit(data) {
        console.debug("handleSubmit")
        if (!this.isValidPromotion()) {
            this.setState({validateForm: true})
            return
        }
        const promotion = this.props.promotion || {}
        const {isCreate, loadPromotions, brandId} = this.props
        const {name, imageURL, headline, message, legal, startDate, endDate, ctaUrl, ctaCopy, ctaColor, codes, shouldSubmitCodes} = this.state
        const requestData = {
            ...(name !== promotion.name && {name: name}),
            ...(brandId !== promotion.brandId && {brandId: brandId}),
            ...(imageURL !== promotion.imageURL && {imageURL: imageURL}),
            ...(headline !== promotion.headline && {headline: headline}),
            ...(message !== promotion.message && {message: message}),
            ...(legal !== promotion.legal && {legal: legal}),
            ...((!promotion.startDate || startDate.format('LL') !== moment.utc(promotion.startDate).format('LL')) && {startDate: this.state.startDate.add(this.state.startDate.utcOffset(), 'm').utc().startOf("day").valueOf()}),
            ...((!promotion.endDate || endDate.format('LL') !== moment.utc(promotion.endDate).format('LL')) && {endDate: this.state.endDate.add(this.state.endDate.utcOffset(), 'm').utc().startOf("day").valueOf()}),
            ...(ctaUrl !== promotion.ctaUrl && {ctaUrl: ctaUrl}),
            ...(ctaCopy !== promotion.ctaCopy && {ctaCopy: ctaCopy}),
            ...(ctaColor !== promotion.ctaColor && {ctaColor: ctaColor}),
            ...((isCreate || shouldSubmitCodes) && {codes: codes}),
            ...(isCreate && {status: 'DRAFT'})
        }
        this.setState({isUpdating: true, error: null});
            if (this.props.isCreate) {
                this.props.createPromotion({
                    brandId: brandId,
                    // agencyId: agencyId,
                    ...requestData
                })
                    .then((res) => {
                        return loadPromotions()
                        .then(() => {
                            this.props.history.replace(`${this.getBackLink()}/${res.instance.id}`);
                        })
                    })
                    .then((res) => this.handleSuccess())
                    .catch((err) => this.handleFailure(err));
            } else {
                this.props.updatePromotion(this.props.promotion.id, requestData)
                    .then((res) => this.handleSuccess())
                    .catch((err) => this.handleFailure(err));
            }
    }

    onActivateClick(){
        this.setState({isActivating: true, error: null});
        this.props.updatePromotion(this.props.promotion.id, {status: 'ACTIVE'})
            .then((res) => this.props.history.push(this.getBackLink(), {needUpdatePromotions: true}))
            .catch((err) => {
                console.log(err)
                try {
                    this.handleFailure(JSON.parse(err.message.replace(/'/g, '"')))
                } catch (e) {
                    this.handleFailure({message: err.message.replace(/'/g, '"')})
                }
            });
    }

    handleSuccess() {
        this.setState({isUpdating: false, isActivating: false, codes: [], shouldSubmitCodes: false});
    }

    handleFailure(err) {
        this.setState({error: err, isUpdating: false, isActivating: false});
    }

    getSubmitText() {
        if (this.state.isUpdating && this.props.isCreate) {
            return 'Creating';
        } else if (this.state.isUpdating) {
            return 'Updating';
        } else if (this.props.isCreate) {
            return 'Create';
        } else {
            return 'Update';
        }
    }

    getBackLink() {
        return this.props.match.url.substring(0, this.props.match.url.lastIndexOf('/'));
    }

    render() {
        const { isCreate, promotion } = this.props;
        const {status, name, imageURL, headline, message, legal, startDate, endDate, ctaUrl, ctaCopy, ctaColor, codes, ctaColorValid, count, shouldSubmitCodes} = this.state

        const {
            isUpdating,
            isActivating,
            validateForm,
            error
        } = this.state;

        if (!isCreate && !promotion) {
            return <div>Promotion failed to load</div>
        }

        console.log((!name || name.length === 0) && validateForm)

        return (
            <Container className="EditPromotion">
                <Row>
                    <Col xs='10'>
                        <h3>{isCreate ? 'Create Promotion' : `Edit ${promotion.name}`}</h3>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form onSubmit={this.handleSubmit.bind(this)}>
                            <FormGroup row>
                                <Label for="name" sm={4}>Name</Label>
                                <Col sm={8}>
                                    <Input name="name"
                                           id="name"
                                           defaultValue={name}
                                           onChange={(e) => this.setState({ name: e.target.value })}
                                           invalid={(!name || name.length === 0) && validateForm}/>
                                    {(!name || name.length === 0) && <FormFeedback>Name is required</FormFeedback> }
                                    <FormText>This is internal only, not shown to users</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="imageURL" sm={4}>Tile Image Upload</Label>
                                <Col sm={8}>
                                    <DroppableFileInput
                                        id='imageURL'
                                        text='Tile Image'
                                        fileType='image'
                                        onChange={(image) => this.setState({imageURL: image.large})}
                                        cropperAspectRatio={1/2}
                                        existingFileName={imageURL ? imageURL .split('/').pop(): ''}
                                        existingFileURL={imageURL }
                                        warning={ imageURL  || !validateForm ? '' : 'Tile Image is required'}
                                    />
                                    <Row><Col sm={12}><FormText>MVP: Single image 1w x 2h dimension</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4} for='startDate'>Start Date</Label>
                                <Col sm={8}>
                                    <DateInput id='startDate'
                                               className='form-control'
                                               minDate={moment().startOf("day")}
                                               selected={startDate}
                                               onChange={(d) => this.setState({startDate: d})}
                                    />
                                    <FormFeedback>Incorrect Date</FormFeedback>
                                    <Row><Col sm={12}><FormText>When should Tile go live?</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4} for='endDate'>End Date</Label>
                                <Col sm={8}>
                                    <DateInput id='endDate'
                                               className='form-control'
                                               disabled={!startDate}
                                               minDate={startDate || moment().startOf("day")}
                                               selected={endDate}
                                               onChange={(d) => {
                                                   this.setState({endDate: d});
                                               } }
                                    />
                                    {startDate >= endDate && validateForm &&
                                    <FormText color='danger'>End date should be greater than start date</FormText>
                                    }
                                    <Row><Col sm={12}><FormText sm={12}>When should Tile expire?</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="headline" sm={4}>Message Headline</Label>
                                <Col sm={8}>
                                    <Input name="headline"
                                           id="headline"
                                           defaultValue={headline}
                                           onChange={(e) => this.setState({ headline: e.target.value })}
                                           invalid={(!headline || headline.length === 0) && validateForm}/>
                                    {(!headline || headline.length === 0) && <FormFeedback>Message Headline is required</FormFeedback> }
                                    <FormText>What should the Headline read once user taps and opens pop-up?</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="message" sm={4}>Message Body</Label>
                                <Col sm={8}>
                                    <Input name="message"
                                           id="message"
                                           defaultValue={message}
                                           onChange={(e) => this.setState({ message: e.target.value })}
                                           invalid={(!message || message.length === 0) && validateForm}/>
                                    {(!message || message.length === 0) && <FormFeedback>Message Body is required</FormFeedback> }
                                    <FormText>What should the message read once user taps and opens pop-up?</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="legal" sm={4}>Message Legal Footer</Label>
                                <Col sm={8}>
                                    <Input name="legal"
                                           id="legal"
                                           defaultValue={legal}
                                           onChange={(e) => this.setState({ legal: e.target.value })}
                                           invalid={(!legal || legal.length === 0) && validateForm}/>
                                    {(!legal || legal.length === 0) && <FormFeedback>Message Legal Footer is required</FormFeedback> }
                                    <FormText>What should the Legal read once user taps and opens pop-up?</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="upcs" sm={4}>Upload Codes</Label>
                                <Col sm={8}>
                                    <Label for="codes_upload" className="btn">Upload List</Label>
                                    <Input type="file" name="file" id="codes_upload" accept='.csv'
                                           invalid={(isCreate && codes.length === 0 && shouldSubmitCodes) && validateForm}
                                           onChange={(e) => this.handleFileUploadChange(e)} style={{display: 'none'}}/>

                                    {codes.length === 0 && !isCreate &&
                                        <span> {`${count} codes`} </span>
                                    }
                                           {codes.length > 0 &&
                                        <span> {`${codes.length} codes to upload`} </span>
                                    }
                                    {(codes.length > 0 && isCreate) &&
                                        <Button2 color="link" onClick={(e) => this.clearCodes(e)}> Clear Codes </Button2>
                                    }
                                    <FormFeedback>Promo Codes are required</FormFeedback>
                                    <Row><Col sm={12}><FormText>Upload file in .csv format, all codes with alphanumeric characters will be processed.</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="ctaCopy" sm={4}>CTA Copy</Label>
                                <Col sm={8}>
                                    <Input name="ctaCopy"
                                           id="ctaCopy"
                                           defaultValue={ctaCopy}
                                           onChange={(e) => this.setState({ ctaCopy: e.target.value })}
                                           invalid={(!ctaCopy || ctaCopy.length === 0 || ctaCopy.length > 25) && validateForm}/>
                                    {(!ctaCopy || ctaCopy.length === 0 || ctaCopy.length > 25) && <FormFeedback>CTA Copy is required</FormFeedback> }
                                    <FormText>What should the CTA on pop-up read? Example: "Redeem Now" or "Sign-up Now"</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="ctaUrl" sm={4}>CTA Url</Label>
                                <Col sm={8}>
                                    <Input name="ctaUrl"
                                           id="ctaUrl"
                                           defaultValue={ctaUrl}
                                           onChange={(e) => this.setState({ ctaUrl: e.target.value })}
                                           invalid={(!ctaUrl || ctaUrl.length === 0) && validateForm}/>
                                    {(!ctaUrl || ctaUrl.length === 0) && <FormFeedback>CTA Url is required</FormFeedback> }
                                    <FormText>Provide full URL for CTA</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup color={ctaColorValid ? '' : 'danger'} row>
                                <Label for='ctaColor' sm={4}>CTA Color</Label>
                                <Col sm={8}>
                                    <ColorInput
                                        id='ctaColor'
                                        name='ctaColor'
                                        defaultValue={ctaColor}
                                        placeholder='#FF00FF'
                                        onChange={this.handleColorChange.bind(this)}
                                    />
                                    {!ctaColorValid && validateForm &&
                                    <FormText color='danger'>Color is required</FormText>
                                    }
                                    <Row><Col sm={12}><FormText>Background color for the CTA button</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <br/>
                            {error &&
                                <div>
                                    { Object.entries(error).map(([key, value]) => <FormText color='danger' key={value}>{value}</FormText>)}
                                    <br/>
                                </div>
                            }
                            <div>
                                <Button isSubmit disabled={isUpdating}>{this.getSubmitText()}</Button>
                                { status === 'DRAFT' &&
                                    <Button className='ml-2' disabled={isUpdating || isActivating || !this.isValidPromotion()}
                                            onClick={() => this.onActivateClick()}>{this.state.isActivating ? 'Activating...' : 'Activate'}</Button>
                                }
                                <Button
                                    linkHref={this.getBackLink()}
                                    className='float-right'
                                    textColor='#666666'
                                    borderColor='#cccccc'
                                    backgroundColor='#ededed'> Cancel </Button>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default EditPromotion;



// WEBPACK FOOTER //
// ./src/routes/EditPromotion/components/EditPromotion.js